// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"364":"715da94d","750":"ff31cf79"}[chunkId] + ".css";
};